import { HausbankFieldTypes } from './fields';

export const hausbankSteps: Record<keyof HausbankFieldTypes, keyof HausbankFieldTypes> = {
  objectInformationPage: 'objectInformationPage',
  companyDataPage: 'companyDataPage',
  financingNeedPage: 'financingNeedPage',
  personalDataPage: 'personalDataPage',
} as const;
